import store from '@/state/store'
import { Helper } from '@/mixin/helper'

const companyId = Helper.methods.getCompanyId()

const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']
const hasAccessAll = store.getters['identity/hasAccessAll']

const isManuallyAssignVehicle = hasAccessAll(['route-optimization-manually-assign-vehicle:read'])
const isRoSwatActive = store.getters['identity/getFeatureStrategies']('ro.swat-mobility', companyId)?.active || false
const isRoSwatSamator = store.getters['identity/getFeatureStrategies']('ro.swat-mobility', companyId)?.is_samator || false

export const FORM_CREATE_ROUTE_OPTIMIZE_DEFAULT = {
  start_address_id: null,
  user_group_id: null,
  expected_departure_on: null,
  expected_end_on: null,
  vehicle_ids: [],

  delivery_orders: [],
  delivery_order_ids: [],

  'options.service_time': 'PT15M',

  'options.fleet_shift_time.start_break_time': null,
  'options.fleet_shift_time.end_break_time': null,

  'options.minimum_vehicle': true,
  'options.avoid_tolls': true,

  'options.weight_capacity': false,
  'options.volume_capacity': false,

  'options.round_trip': false,
  'options.group_order': true,
  'options.routing_method': 'VRP',
  'options.window_time': true,
  'options.traffic_level': 'slow',

  'options.is_service_time_per_activity':
    isRoSwatActive && isRoSwatSamator,

  ...(isRoSwatActive && isRoSwatSamator
    ? {
        'options.pickup_location_optimization': true,
        'options.box_type_capacity': false,
      }
    : {}),

  ...(isManuallyAssignVehicle
    ? {
        'options.manually_assign_vehicle': false,
      }
    : {}),
}
